import React from 'react'
import vits_logo from "..//../assets/vitsnamelogo.png"
import "./footer.css"
function Footer() {
  return (
    <div className='footer_container'>
        <footer className="footer_sub">
                <div className="footer-col">
                    <img className='vits_logo' src={vits_logo} alt="" />
                    <p><i className='fa fa-map-marker'></i> karhi road amaudha 485001</p>
                    <p><i className='fa fa-phone'></i> Contact us : 8754258565</p>
                    <p><i className='fa fa-envelope'></i> Email :vits1234@gmai.com</p>
                    
                </div>
                <div className="footer-col">
                    <h4>Company</h4>
                    <ul>
                        <li><i className='fa fa-angle-right'></i> <a href="">About us</a></li>
                        <li><i className='fa fa-angle-right'></i> <a href="">Services</a></li>
                        <li><i className='fa fa-angle-right'></i> <a href="">Privacy policy</a></li>
                        <li><i className='fa fa-angle-right'></i> <a href="">Affiliate program</a></li>
                    </ul>
                </div>
                <div className="footer-col">
                    <h4>Get help</h4>
                    <ul>
                        <li><i className='fa fa-angle-right'></i> <a href="">FAQ</a></li>
                        <li><i className='fa fa-angle-right'></i> <a href="">Email</a></li>
                        <li><i className='fa fa-angle-right'></i> <a href="">Form</a></li>
                        <li><i className='fa fa-angle-right'></i> <a href="">Status</a></li>

                    </ul>
                </div>
                <div className="footer-col">
                    <h4>Online help</h4>
                    <ul>
                        <li><i className='fa fa-angle-right'></i> <a href="">Rgpv</a></li>
                        <li><i className='fa fa-angle-right'></i> <a href="">Exam</a></li>
                        <li><i className='fa fa-angle-right'></i> <a href="">Resultl</a></li>
                        <li><i className='fa fa-angle-right'></i> <a href="">Calender</a></li>
                    </ul>
                </div>
                <div className="footer-col">
                    <h4>Follow Us</h4>
                    <div className="social-links">
                        <a href=""><i className="fab fa-facebook-f"></i></a>
                        <a href=""><i className="fab fa-twitter"></i></a>
                        <a href=""><i className="fab fa-whatsapp"></i></a>
                        <a href=""><i className="fab fa-instagram"></i></a>
                    </div>
                </div>
        </footer>
                <p className='copyright'>Created by Atul Rajak & All right reserved &copy; 2024</p>

    </div>
  )
}

export default Footer